
import classNames from 'classnames'

import styles from './link.module.sass'

function Link(props) {

	const displayedProps = {
		href: props.href || props.url,
		alt: props.alt,
		target: props.target,
		title: props.title
	}

	return <a {...displayedProps} className={classNames(styles.link, props.className)}>{props.children}</a>
}

export default Link